export default {
  container: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    '& > *': {
      marginLeft: '10px',
      '&:first-child': {
        marginLeft: '0'
      }
    }
  },
  pending: {
    opacity: '0.5',
    pointerEvents: 'none'
  }
}
